/**
 * Shared helpers for rendering trial-usage UI (sidebar widget, billing page,
 * onboarding upgrade page). Keep these pure — the reactive state lives in
 * `useTrialUsage`.
 */

export type TrialUsageProgressColor = "primary" | "yellow" | "red";

/** Pick a progress-bar color from a 0–100 percentage. */
export function pickTrialProgressColor(percent: number): TrialUsageProgressColor {
  if (percent >= 100) return "red";
  if (percent >= 80) return "yellow";
  return "primary";
}

/**
 * Format a call-seconds total as a short human-friendly duration ("12m",
 * "1.3h"). Rounds to the nearest minute, then to 0.1h when it exceeds 60min.
 */
export function formatTrialDurationShort(seconds: number): string {
  if (seconds <= 0) return "0m";
  const totalMinutes = Math.round(seconds / 60);
  if (totalMinutes < 60) return `${totalMinutes}m`;
  const hours = totalMinutes / 60;
  const rounded = Math.round(hours * 10) / 10;
  return `${rounded}h`;
}
